
import firebase from "firebase/compat/app"
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyB1hPk5A6JsVidLIa6uDfdKSWAs9uH6n7w",
    authDomain: "slack-clone-ff7f1.firebaseapp.com",
    projectId: "slack-clone-ff7f1",
    storageBucket: "slack-clone-ff7f1.appspot.com",
    messagingSenderId: "108126553981",
    appId: "1:108126553981:web:985f2d7101f8223d816e14",
    measurementId: "G-TK3K0Y48HR"
  };

  const firebaseApp = firebase.initializeApp(firebaseConfig)
  const db =firebaseApp.firestore()
  const auth = firebase.auth()
  const provider = new firebase.auth.GoogleAuthProvider()

//   explicit export vs a default export. remember they get imported differently. you can rename default exports on import
  export { auth, provider };
  export default db
  